import React from 'react'
import { createUseStyles, FormControl as AirbusFormControl } from '@airbus/components-react/components'
import { FormControlProps } from '@airbus/components-react/components/Form'
import clsx from 'clsx'

const useStyles = createUseStyles(
  () => ({
    required: {
      '& #form-control-label::after': {
        content: '" *"',
        color: 'red',
        marginLeft: 4,
      },
    },
    hide_optional: {
      '& #form-control-label': {
        display: 'flex',
        marginBottom: 0,
      },
      '& #form-control-label > [class$="optional"]': {
        display: 'none',
      },
    },
  }),
  'form-control-container',
)

const FormControl = ({
  label,
  error,
  readOnly = false,
  labelAdornment,
  required = false,
  children,
  style,
  className,
}: FormControlProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(className, classes.hide_optional, !readOnly && required && classes.required)} style={style}>
      <AirbusFormControl id='form-control' label={label} error={error} labelAdornment={!readOnly && labelAdornment}>
        {children}
      </AirbusFormControl>
    </div>
  )
}

export default FormControl
